import { useEffect, useState } from 'react';

const REVIEWS: { quote: string; name: string }[] = [
  { quote: "My skin looks like a different person's. The plan actually fits my life — no 12-step nonsense.", name: 'Sarah, 34' },
  { quote: 'Finally feels like skincare designed for me, not someone else.', name: 'Marcus, 29' },
  { quote: 'Down 6 years of skin age in 8 weeks. I’m a believer.', name: 'Emily, 41' },
  { quote: 'The breakdown alone was worth it. I finally understand why my old routine failed.', name: 'Aisha, 27' },
  { quote: 'I’ve tried everything. This is the first thing that actually worked.', name: 'Jordan, 38' },
];

export function ReviewCarousel() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => setIdx(i => (i + 1) % REVIEWS.length), 4500);
    return () => window.clearInterval(id);
  }, []);

  const r = REVIEWS[idx];
  return (
    <div className="flex flex-col items-stretch gap-3">
      <div
        key={idx}
        className="lume-card-bordered animate-[fadein_0.5s_ease]"
      >
        <div className="flex gap-0.5 mb-2.5">
          {Array.from({ length: 5 }).map((_, i) => (
            <span key={i} className="text-accent text-xs">★</span>
          ))}
        </div>
        <p className="text-body text-text-secondary leading-relaxed">{r.quote}</p>
        <p className="text-caption text-text-tertiary mt-2.5">— {r.name}</p>
      </div>
      <div className="flex justify-center gap-1.5">
        {REVIEWS.map((_, i) => (
          <span
            key={i}
            className={`h-1.5 w-1.5 rounded-full transition-colors ${
              i === idx ? 'bg-accent' : 'bg-surface-raised'
            }`}
          />
        ))}
      </div>
      <style>{`@keyframes fadein { from { opacity: 0 } to { opacity: 1 } }`}</style>
    </div>
  );
}
